export default "__VITE_ASSET__B18ZJdCU__"